
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RouteParams from "@/entities/RouteParams";

  @Component
  export default class UILink extends Vue {
    @Prop({ type: String, required: true }) readonly content!: string;
    @Prop({ type: Object, required: true }) readonly routeParams!: RouteParams<{}>;
    @Prop({ type: Boolean, default: true }) readonly underline!: boolean;
    @Prop({ type: Boolean, default: false }) readonly textBase!: boolean;

    get classes(): Record<string, boolean> {
      return {
        "underline": this.underline,
        "text-base": this.textBase,
      }
    }
  }
